var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrcodescanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.5H4.5V7.5H7.5V4.5ZM9 3V9H3V3H9ZM7.5 12.4688H4.5V15.4688H7.5V12.4688ZM9 10.9688V16.9688H3V10.9688H9ZM15.4688 4.5H12.4688V7.5H15.4688V4.5ZM16.9688 3V9H10.9688V3H16.9688ZM10.9688 10.9688V12.4688H12.4688V10.9688H10.9688ZM12.4688 12.4688V13.9688H13.9688V12.4688H12.4688ZM13.9688 10.9688V12.4688H15.4688V10.9688H13.9688ZM10.9688 13.9688V15.4688H12.4688V13.9688H10.9688ZM12.4688 15.4688V16.9688H13.9688V15.4688H12.4688ZM13.9688 13.9688V15.4688H15.4688V13.9688H13.9688ZM15.4688 12.4688V13.9688H16.9688V12.4688H15.4688ZM15.4688 15.4688V16.9688H16.9688V15.4688H15.4688ZM19.9688 4.96875V0H15V1.96875H18V4.96875H19.9688ZM19.9688 19.9688H15V18H18V15H19.9688V19.9688ZM0 19.9688V15H1.96875V18H4.96875V19.9688H0ZM0 0H4.96875V1.96875H1.96875V4.96875H0V0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcodescanner);
export default __webpack_public_path__ + "static/media/qrcodescanner.a3a12686464c0b09722533e90e7f7ad8.svg";
export { ForwardRef as ReactComponent };